import apiClient from './client';

// The Comments/Questions form: {name?, email?, message}. Accepted with a 202;
// the email is sent in the background.
export const sendFeedback = (payload) => apiClient.post('/feedback', payload).then(() => undefined);
